<div [class]="skinName">
  <div id="payment-step" class="payment-options-bg">
    <app-plan-info [oldUser]="subscriptionService.planDetails" [showIntent]="false" [paymentIntent]="configService.localeKeys?.['plans.set_up_your_payment.text']"></app-plan-info>
    <app-signup-step [backRoute]="backRoute" [currentStep]="currentStep" (emitStep)="getSignStep($event)" [gotToPreviousPopUp]="previous"  [showChangePlan]="true"></app-signup-step>
    @if (cardAvail) {
      <div class="payment-method" (click)="redirectToPaymentPage(routerNav.card, 'card')">
        <div class="title">{{configService.localeKeys?.signup_pymnt_card || 'Credit or debit card'}}</div>
        <div class="icon icon-width">
          <img id="visa" class="pr-5 luminous" src="branding/theme/assets/static_assets/ic-visa.svg" alt="visa">
          <img class="pr-5 luminous" src="branding/theme/assets/static_assets/ic-mastercard.svg" alt="master-card">
          <img class="back" src="branding/theme/assets/static_assets/ic-left-arrow-on-lbg.svg" alt="select-credit" >
        </div>
      </div>
    }
    @if (idealAvail) {
      <div class="payment-method" [ngClass]="{'account-payment-method': page === 'account'}" (click)="redirectToPaymentPage(routerNav.ideal, 'ideal')">
        <div class="title">{{configService.localeKeys?.signup_pymnt_ideal || 'iDeal'}}</div>
        <div class="icon">
          <img id="ideal-logo" class="pr-5" src="branding/theme/assets/static_assets/ic-ideal.svg" alt="iDeal">
          <img class="back" src="branding/theme/assets/static_assets/ic-left-arrow-on-lbg.svg" alt="select-ideal">
        </div>
      </div>
    }
  </div>
  @if (paymentGateway === 'stripe') {
    <app-stripe-info></app-stripe-info>
  }

</div>